<template>
    <ContentOrLoading>
        <MainContent v-if="evento && informe" :title="'Evento: ' + evento.nombre" format="plain">
            <template v-slot:header>
                <b-row>
                    <b-col cols="12">
                        <div class="d-flex flex-wrap flex-md-row flex-column gap-2">
                            <router-link v-if="!isTaquilleroVisitante" :to="{ name: 'back.events.sales-ad.index', params: { evento_id: id } }" class="btn btn-primary m-1">
                                AVISOS DE VENTAS
                            </router-link>

                            <router-link v-if="!isTaquilleroVisitante" :to="{ name: 'back.events.informe.emails', params: { evento_id: id } }" class="btn btn-primary m-1">
                                <i class="fa fa-chart-line"></i> ESTADÍSTICAS EMAILS
                            </router-link>
                            <Button v-if="!isTaquilleroVisitante" class="m-1" @click="showModal('descargar-informe')">DESCARGAR INFORME + DETALLE</Button>
                            <Button class="m-1" @click="showModal('descargar-informe-economico')">DESCARGAR INFORME ECONOMICO</Button>
                            <Button class="m-1" @click="showModal('descargar-informe-arqueo-caja')">DESCARGAR INFORME ARQUEO DE CAJA</Button>
                            <Button class="m-1" @click="showModal('descargar-informe-taquilla')">DESCARGAR INFORME TAQUILLA</Button>
                            
                            <DescargarInforme
                                :ruta="'back.events.informe'" 
                                v-on:close="closeModal"
                                name="descargar-informe"
                                :detalle="true"
                                :evento_id="id"
                                :sesiones="evento.sesiones"
                                :taquillero_id="taquillero_id"
                            />
                            <DescargarInforme
                                :ruta="'back.events.informe'" 
                                v-on:close="closeModal"
                                name="descargar-informe-economico"
                                :detalle="false"
                                :evento_id="id"
                                :sesiones="evento.sesiones"
                                :taquillero_id="taquillero_id"
                            />
                            <DescargarInformeControlAcceso
                                name="descargar-informe-control"
                                :evento="evento"
                                :taquillero_id="taquillero_id"
                                :sesion_id="sesion_id"
                                v-on:close="closeModal"
                            />
                            <DescargarInformeArqueoCaja
                                name="descargar-informe-arqueo-caja"
                                :key="reload"
                                :evento_id="evento.id"
                                :sesion_id="sesion_id"
                                :taquillero_id="taquillero_id"
                                :sesiones="sesiones"
                                :taquilleros="taquilleros"
                                @close="closeModal; reload++"
                            />
                            <DescargarInforme
                                name="descargar-informe-taquilla"
                                ruta="back.events.informe" 
                                :detalle="false"
                                :evento_id="id"
                                :sesiones="evento.sesiones"
                                :taquillero_id="taquillero_id"
                                @close="closeModal"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" class="mt-3">
                        <span>
                            <b>Observaciones:</b>
                            <p id="observaciones" v-if="evento.observaciones"><small>{{evento.observaciones}}</small></p>
                            <Button class="button small-button ml-3" @click="showModal('editar-observaciones')" id="edit-comments">Editar</Button>
                        </span>

                        <EditarObservacionesModel :evento="evento" v-on:close="closeModal"/>
                    </b-col>
                </b-row>
            </template>
            <template v-slot:content>
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <TotalRecaudacionComponent
                            :event_id="id"
                            :informe="informe"
                            :sesiones="sesiones"
                            :taquilleros="taquilleros"
                            v-on:actualizar="getInforme"
                        />
                    </div>
                    <div class="col-12 col-lg-4">
                        <GraficosVentasComponent :event_id="id" :taquillero_id="taquillero_id" :sesion_id="sesion_id" :manager="manager" :informe_ventas_normal_abonos="informe_ventas_normal_abonos"/>
                    </div>
                    <template>
                        <div class="col-12 col-lg-4">
                            <VentaDiariaComponent :event_id="id" :taquillero_id="taquillero_id"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <VentaOnlineComponent :event_id="id" :informe="informe" @totalVentas="totalVentasOnline = $event"/>
                        </div>
                        <div class="col-12">
                            <VentaTaquillaComponent :event_id="id" :informe="informe_con_taquilleros" @totalVentas="totalVentasTaquilla = $event"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <ProductosComponent :event_id="id" :sesion_id="sesion_id" :taquillero_id="taquillero_id" />
                        </div>
                        <div class="col-12">
                            <VentaOnlineAgrupadaComponent :event_id="id" :informe="informe_agrupado" @totalVentas="totalVentasOnline = $event"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <EntradasOtrosComponent :event_id="id" :sesion_id="sesion_id"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <DevolucionesComponent :event_id="id" :informe="devoluciones" />
                        </div>
                        <div class="col-12" v-if="manager.tipo == 2 && !isTaquilleroVisitante">
                            <VentasAbonosComponent :event_id="id" :informe="abonos" />
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <InvitacionesComponent :event_id="id" :informe="informe" />
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <InvitacionesAgrupadasComponent :event_id="id" :informe="informe_agrupado" />
                        </div>
                        <div class="col-12 mb-3" v-if="!isTaquilleroVisitante">
                            <ProcedenciaComponent :event_id="id" @entradasPorProvincia="totalEntradasProvincia = $event" @entradasPorCP="totalEntradasCP = $event"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <GeneroComponent :event_id="id" @totalGeneros="totalGeneros = $event"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <GraficoEdadComponent :event_id="id" @totalEdades="totalEdades = $event"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <GraficoComprasPorHoraComponent :event_id="id" @totalHorasVentas="totalHorasVentas = $event"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <CompradoresRecurrentesVsNuevos :event_id="id"/>
                        </div>
                        <div class="col-12" v-if="!isTaquilleroVisitante">
                            <CategoriasDispositivos :event_id="id"/>
                        </div>
                        <div class="col-12" v-if="evento.permitir_liberacion_asientos && !isTaquilleroVisitante">
                            <AsientosLiberadosComponent :event_id="id"/>
                        </div>
                        <template v-if="evento.place_id && !isTaquilleroVisitante">
                            <div class="col-12">
                                <OcupacionComponent :event_id="id" :sesiones="sesiones"/>
                            </div>
                            <div class="col-12">
                                <AccesoComponent :event_id="id" :sesiones="sesiones"/>
                            </div>
                        </template>
                        <template v-if="totalVentasOnline > -1 && totalVentasTaquilla > -1 && totalEdades.length > 0 && totalGeneros.length > 0 && totalHorasVentas.length > 0 && totalEntradasProvincia != null && totalEntradasCP != null">
                            <div class="col-12" v-if="!isTaquilleroVisitante">
                                <ResumenComponent
                                    :totalVentasOnline="totalVentasOnline"
                                    :totalVentasTaquilla="totalVentasTaquilla"
                                    :totalEdades="totalEdades"
                                    :totalGeneros="totalGeneros"
                                    :totalHorasVentas="totalHorasVentas"
                                    :totalEntradasProvincia="totalEntradasProvincia"
                                    :totalEntradasCP="totalEntradasCP"
                                />
                            </div>
                        </template>
                    </template>
                </div>
            </template>
        </MainContent>
    </ContentOrLoading>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import TotalRecaudacionComponent from '@/components/backend/estadisticas/eventos/TotalRecaudacionComponent';
    import GraficosVentasComponent from '@/components/backend/estadisticas/eventos/GraficosVentasComponent';
    import VentaDiariaComponent from '@/components/backend/estadisticas/eventos/VentaDiariaComponent';
    import VentaOnlineComponent from '@/components/backend/estadisticas/eventos/VentaOnlineComponent';
    import VentaTaquillaComponent from '@/components/backend/estadisticas/eventos/VentaTaquillaComponent';
    import EntradasOtrosComponent from '@/components/backend/estadisticas/eventos/EntradasOtrosComponent';
    import VentasAbonosComponent from '@/components/backend/estadisticas/eventos/VentasAbonosComponent';
    import InvitacionesComponent from '@/components/backend/estadisticas/eventos/InvitacionesComponent';
    import DevolucionesComponent from '@/components/backend/estadisticas/eventos/DevolucionesComponent';
    import EditarObservacionesModel from "./modals/EditarObservacionesModel";
    import OcupacionComponent from "@/components/backend/estadisticas/eventos/OcupacionComponent";
    import AccesoComponent from "@/components/backend/estadisticas/eventos/AccesoComponent";
    import ProcedenciaComponent from "@/components/backend/estadisticas/eventos/ProcedenciaComponent"
    import GeneroComponent from "@/components/backend/estadisticas/eventos/GeneroComponent.vue";
    import GraficoEdadComponent from "@/components/backend/estadisticas/eventos/GraficoEdadComponent.vue";
    import GraficoComprasPorHoraComponent from "@/components/backend/estadisticas/eventos/GraficoComprasPorHoraComponent.vue";
    import DescargarInformeControlAcceso from "./modals/DescargarInformeControlAcceso.vue";
    import CompradoresRecurrentesVsNuevos from "@/components/backend/estadisticas/eventos/CompradoresRecurrentesVsNuevos.vue";
    import CategoriasDispositivos from "@/components/backend/estadisticas/eventos/CategoriasDispositivos.vue";
    import ResumenComponent from "@/components/backend/estadisticas/eventos/ResumenComponent.vue";
    import AsientosLiberadosComponent from "@/components/backend/estadisticas/eventos/AsientosLiberadosComponent.vue";
    import DescargarInforme from '@/components/backend/components/DescargarInforme';
    import DescargarInformeArqueoCaja from '@/views/backend/events/modals/DescargarInformeArqueoCaja';
    import VentaOnlineAgrupadaComponent from '@/components/backend/estadisticas/eventos/VentaOnlineAgrupadaComponent';
    import InvitacionesAgrupadasComponent from "@/components/backend/estadisticas/eventos/InvitacionesAgrupadasComponent.vue";
    import ProductosComponent from "@/components/backend/estadisticas/eventos/ProductosComponent.vue";

    export default {
        props: ['id'],
        data() {
            return {
                evento: null,
                informe: null,
                informe_con_taquilleros: null,
                devoluciones: [],
                abonos: [],
                sesiones: null,
                taquilleros: null,
                taquillero_id: null,
                informe_ventas_normal_abonos: null,
                totalVentasOnline: null,
                totalVentasTaquilla: null,
                totalEdades: [],
                totalGeneros: [],
                totalHorasVentas: [],
                totalEntradasProvincia: null,
                totalEntradasCP: null,
                sesion_id: null,
                reload: 1,
                informe_agrupado: null
            }
        },
        created() {
            if (this.events_can_view.length > 0 && !this.events_can_view.includes(this.id)) {
                this.$router.push('/');
            }
            this.getEvent();
            this.getInforme(null, null);
            this.getTaquilleros();
        },
        computed: {
            event_can_view() {
                return this.$store.getters.getEventCanView;
            },
            events_can_view() {
                return this.$store.getters.getEventsCanView;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            isTaquilleroVisitante() {
                return this.$store.getters.getUser.role === 11;
            },
            user(){
                return this.$store.getters.getUser;
            }
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },

            closeModal(modal, edited) {
                this.$modal.hide(modal);

                if (edited) {
                    this.getEvent();
                }
            },
            getEvent: function() {
                const params = {
                    filters: {},
                    evento_id: this.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.show'), params).then(res => {
                    this.evento = res.data.data;
                    this.sesiones = res.data.data.sesiones;
                });
            },
            getInforme(sesion, taquillero) {
                this.taquillero_id = taquillero;
                this.sesion_id = sesion;

                const params = {
                    filters: {
                        sesion_id: sesion,
                        taquillero_id: taquillero
                    },
                    evento_id: this.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.informe'), params).then(res => {
                    this.informe = res.data.venta_diaria;
                    this.informe_agrupado = res.data.venta_diaria_agrupada;
                    this.informe_con_taquilleros = res.data.venta_diaria_con_taquilleros;
                    this.devoluciones = res.data.devoluciones;
                    this.abonos = res.data.abonos;
                });

                this.$store.dispatch(this.config.getVuexAlias('back.events.show.normal-abonos-ventas'), params).then(res => {
                    this.informe_ventas_normal_abonos = res.data;
                });
            },
            getTaquilleros() {
                this.$store.dispatch(this.config.getVuexAlias('back.taquilleros.index'), { filters: { select: 'ALL' } }).then(res => {
                    this.taquilleros = res.data.data;
                });
            }
        },

        components: {
            AccesoComponent,
            EditarObservacionesModel,
            OcupacionComponent,
            ResumenComponent,
            TotalRecaudacionComponent, VentaDiariaComponent, VentaOnlineComponent, VentaTaquillaComponent, EntradasOtrosComponent,
            InvitacionesComponent, DescargarInforme, DevolucionesComponent, MainContent, VentasAbonosComponent,
            ProcedenciaComponent, GraficosVentasComponent, GeneroComponent, DescargarInformeControlAcceso,
            GraficoEdadComponent, GraficoComprasPorHoraComponent, CompradoresRecurrentesVsNuevos, CategoriasDispositivos,
            AsientosLiberadosComponent, DescargarInformeArqueoCaja, VentaOnlineAgrupadaComponent, InvitacionesAgrupadasComponent,
            ProductosComponent
        }
    }
</script>
